
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restrict",
      function () {
        return require("private-next-pages/restrict.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restrict"])
      });
    }
  